import { Input } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import {
  InvoiceListSourceTypeParam,
  InvoiceListSourceTypeParamLabelMap,
  InvoiceListSourceTypeParamValue,
  InvoiceStatus,
  InvoiceStatusMap,
} from "features/Invoices/constants/invoice.constants";
import type { SelectOption } from "types/api.types";

export type InvoiceListFiltersProps = {
  section?: "inline" | "extended";
  status: string;
  onStatusChange: (value: string) => void;
  sourceType: string;
  onSourceTypeChange: (value: string) => void;
  clientId: number | null;
  onClientIdChange: (value: number | null) => void;
  issueDateFrom: string;
  onIssueDateFromChange: (value: string) => void;
  issueDateTo: string;
  onIssueDateToChange: (value: string) => void;
  dueDateFrom: string;
  onDueDateFromChange: (value: string) => void;
  dueDateTo: string;
  onDueDateToChange: (value: string) => void;
};

const LIST_SOURCE_TYPES = Object.values(
  InvoiceListSourceTypeParam,
) as InvoiceListSourceTypeParamValue[];

export default function InvoiceListFilters({
  section = "inline",
  status,
  onStatusChange,
  sourceType,
  onSourceTypeChange,
  clientId,
  onClientIdChange,
}: InvoiceListFiltersProps) {
  if (section === "inline") {
    return (
      <div className="d-flex align-items-center gap-2">
        <Input
          type="select"
          className="form-select"
          style={{ width: 150 }}
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          <option value="">All statuses</option>
          {(Object.values(InvoiceStatus) as InvoiceStatus[]).map((s) => (
            <option key={s} value={s}>
              {InvoiceStatusMap[s]?.label ?? s}
            </option>
          ))}
        </Input>

        <Input
          type="select"
          className="form-select"
          style={{ width: 160 }}
          value={sourceType}
          onChange={(e) => onSourceTypeChange(e.target.value)}
        >
          <option value="">All sources</option>
          {LIST_SOURCE_TYPES.map((t) => (
            <option key={t} value={t}>
              {InvoiceListSourceTypeParamLabelMap[t] ?? t}
            </option>
          ))}
        </Input>

        <AsyncPaginatedSelect
          fetchOptions={getClientOptions}
          placeholder="Any client…"
          value={clientId ?? ""}
          onChange={(opt) =>
            onClientIdChange(
              opt && !Array.isArray(opt)
                ? Number((opt as SelectOption).value)
                : null,
            )
          }
        />
      </div>
    );
  }
}
